import { Footer } from './Footer'
import React, { Component } from 'react'
import { Row, Col, Card, Container } from 'react-bootstrap'
import Maniquis1 from './Educativo/Maniquis1.jpg'
import Maniqui2 from './Educativo/Maniqui2.jpg'
import { Navigation } from './Navigation'

export class EqMedico extends Component {
    render() {
        const maniquies = [
            { img: Maniquis1, title: "Maniquíes educativos" },
            { img: Maniqui2, title: "Maniquí Simulador de parto" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Médico/Educativo</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos 2 columnas para que las imágenes de los maniquíes 
                        se vean grandes y no se pierdan los detalles pedagógicos.
                    */}
                    <Row xs={1} lg={2} className="g-5 text-center justify-content-center">
                        {maniquies.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                height: '500px', 
                                                objectFit: 'contain',
                                                padding: '10px'
                                            }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.6rem', padding: '10px' }}>
                                            {item.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}